import FILTER_CONFIG from "./filters.config";

const filterFactory = (type: string) => {
    return FILTER_CONFIG.find((line: any) => line.type == type)
}

export default filterFactory